var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slogan"},[(_vm.showInsurance)?_c('div',{staticClass:"insurance"},[_c('img',{attrs:{"src":require("../assets/bottom-tips.png"),"alt":"美团支付"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }